import React from 'react';
import classnames from 'classnames';
import { PapiDaBrowseFaceted } from '@wix/da-types-papi';
import { IconSize } from '@wix/da-shared-react/pkg/Icons/IconWrap';
import { BiDataHook } from '@wix/da-shared-react/pkg/biLogger';

import { ArrowDownThin } from '@wix/da-shared-react/pkg/Icons/ArrowDown';
import OrderDropdown from '../../../OrderDropdown';
import ContentTypeFilterDropdown from '../../../ContentTypeFilterDropdown';

import s from './NavigationBar.scss';

const renderArrowDown = (className: string) => (
  <ArrowDownThin className={className} size={IconSize.SMALL} />
);

export interface Props {
  orderOptions?: PapiDaBrowseFaceted['orderOptions'];
  order?: string;
  className?: string;
}

const NavigationBar: React.FC<Props> = ({ orderOptions, order, className }) => {
  return (
    <div
      className={classnames(s['root'], className)}
      data-hook={BiDataHook.FILTER_NAV}
    >
      <ContentTypeFilterDropdown
        className={s['dropdown']}
        arrowDown={renderArrowDown}
      />
      <OrderDropdown
        order={order}
        orderOptions={orderOptions}
        className={s['dropdown']}
        arrowDown={renderArrowDown}
      />
    </div>
  );
};
NavigationBar.displayName = 'NavigationBar';

export default NavigationBar;
